import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable no-restricted-globals */
import { Box } from "@gemini/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { NavigationBarTabs } from "./NavigationBarTabs";
import { useIsNavbarSticky } from "./useIsNavbarSticky";
import { useVisibleSectionId } from "./useVisibleSectionId";
import { useTrackingNavigationBar } from "@/hooks/tracking/useTrackingNavigationBar";
import { useGetNavbarVariant } from "@/shared/components/NavigationBar/useGetNavbarVariant";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
import { VariantEnum } from "./types";
export const NavigationBar = () => {
    const { isNavigationBar, variant } = useGetNavbarVariant();
    const [activeTab, setActiveTab] = useState("overview");
    const { visibleSectionId: activeNavigationTab, suspendObserver } = useVisibleSectionId({
        ids: Object.values(TAB_ITEMS),
    });
    const isStickyNavbar = useIsNavbarSticky(isNavigationBar);
    const navbarRef = useRef(null);
    const trackNavigationBarTab = useTrackingNavigationBar();
    //make sure the active tab is always on left side of the navigation bar
    const handleHorizontalScrollToActiveTab = (tabName) => {
        var _a;
        const activeTabButton = document.getElementById("tab-" + tabName);
        const activeTabButtonLeft = 
        // @ts-ignore
        (activeTabButton === null || activeTabButton === void 0 ? void 0 : activeTabButton.offsetLeft) > window.innerWidth / 2
            ? activeTabButton === null || activeTabButton === void 0 ? void 0 : activeTabButton.offsetLeft
            : 0;
        (_a = navbarRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            left: activeTabButtonLeft,
            behavior: "smooth",
        });
    };
    const tabStyles = {
        paddingTop: "spacing.8",
        paddingBottom: "spacing.12",
    };
    if (variant === VariantEnum.TABS) {
        tabStyles["paddingTop"] = "spacing.0";
        tabStyles["paddingBottom"] = "spacing.0";
    }
    useEffect(() => {
        if (activeNavigationTab) {
            setActiveTab(activeNavigationTab);
            activeNavigationTab !== "overview" &&
                handleHorizontalScrollToActiveTab(activeNavigationTab);
        }
    }, [activeNavigationTab]);
    const onTabChange = useCallback((tab) => {
        setActiveTab(tab);
        const section = document.getElementById(tab);
        section === null || section === void 0 ? void 0 : section.scrollIntoView({ behavior: "smooth" });
        suspendObserver(); // Prevent observer from overriding the selected tab during smooth scroll
        trackNavigationBarTab({ additionalProps: { link_text: tab } });
    }, [suspendObserver, trackNavigationBarTab]);
    if (!isNavigationBar)
        return null;
    return (_jsx(Box, Object.assign({ id: "navigation-bar", ref: navbarRef, display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, position: "sticky", top: "spacing.56", backgroundColor: "color.surface.constant.white.default", zIndex: "zIndex.3", unsafe_className: "HideOnPrint", borderBottomWidth: !isStickyNavbar || variant === VariantEnum.TABS
            ? "borderWidth.none"
            : "borderWidth.1", borderBottomColor: !isStickyNavbar || variant === VariantEnum.TABS
            ? "color.surface.transparent.default"
            : "unsafe_component.topBar.color.border", borderBottomStyle: !isStickyNavbar || variant === VariantEnum.TABS ? "none" : "solid", maxWidth: "100vw", width: "100%", overflowX: "scroll", scrollbarWidth: "none", marginBottom: "spacing.24" }, tabStyles, { children: _jsx(NavigationBarTabs, { activeTab: activeTab, onTabChange: onTabChange, variant: variant }) })));
};
